import { RED_700 } from '@mnd-frontend/ui/shared/tokens';
import styled, { keyframes } from 'styled-components';

const rotateBack = keyframes`
  0% { transform: none }
  100% { transform: rotate(-360deg) }
`;

const blobA = keyframes`
  0% { transform: none }
  100% { transform: rotate(360deg) translate(24.5%, 24.5%) }
`;

const blobB = keyframes`
  0% { transform: none }
  100% { transform: rotate(360deg) translate(28.5%, -28.5%) }
`;

const blobC = keyframes`
  0% { transform: none }
  100% { transform: rotate(360deg) translate(-24.5%, 24.5%) }
`;

const blobD = keyframes`
  0% { transform: none }
  100% { transform: rotate(360deg) translate(-16.5%, -16.5%) }
`;

const SvgOuter = styled.svg`
  pointer-events: none;
  position: absolute;

  * {
    transform-origin: 50%;
  }
`;

const Group = styled.g`
  transform-origin: 50%;
  animation: ${rotateBack} 9s linear infinite;

  * {
    transform-origin: 50%;
  }
`;

const CircleA = styled.circle`
  animation: ${blobA} 3s ease-in-out -3s infinite alternate;
`;

const CircleB = styled.circle`
  animation: ${blobB} 8s ease-in-out -3s infinite alternate;
`;

const CircleC = styled.circle`
  animation: ${blobC} 4s ease-in-out -3s infinite alternate;
`;

const CircleD = styled.circle`
  animation: ${blobD} 12s ease-in-out -3s infinite alternate;
`;

const LoaderSmartAnimation = ({
  colorA,
  colorB,
  colorC,
  colorD,
}: {
  colorA?: string;
  colorB?: string;
  colorC?: string;
  colorD?: string;
}) => {
  const blur = 12;
  const alpha = blur * 6;
  const shift = alpha / -2;
  const r = '1 0 0 0 0';
  const g = '0 1 0 0 0';
  const b = '0 0 1 0 0';
  const a = `0 0 0 ${alpha} ${shift}`;

  return (
    <>
      <SvgOuter data-testid="svg">
        <defs>
          <filter colorInterpolationFilters="sRGB" data-testid="filter" id="mnd-onboard-loader">
            <feGaussianBlur data-testid="blur" stdDeviation={blur} />
            <feColorMatrix values={`${r} ${g} ${b} ${a}`} />
          </filter>
        </defs>
      </SvgOuter>
      <div
        data-testid="element"
        style={{
          filter: `url(#mnd-onboard-loader)`,
        }}
      >
        <svg role="img" aria-label="loading..." style={{ height: '12rem', width: '12rem' }}>
          <Group>
            <CircleD cx="50%" cy="50%" r="42" fill={colorD ?? RED_700} />
            <CircleC cx="50%" cy="50%" r="20" fill={colorC ?? RED_700} />
            <CircleB cx="50%" cy="50%" r="30" fill={colorB ?? RED_700} />
            <CircleA cx="50%" cy="50%" r="20" fill={colorA ?? RED_700} />
          </Group>
        </svg>
      </div>
    </>
  );
};

export default LoaderSmartAnimation;
